import axios from 'axios';
import axiosConfig from '../../config/axios.config';
import { checkResponseErrorCodeAndRedirect } from '../../utils/errorHelper'

const CancelToken = axios.CancelToken;

class QueItem {
  constructor(settings) {
    this.id = settings.id;
    this.cacheItem = settings.cacheItem;
    this.status = settings.status;
    this.updateItem = settings.updateItem;
    this.updateStatus = settings.updateStatus;
    this.tabSettings = settings.tabSettings;
    this.isPriority = settings.status === -1;
    this.source = CancelToken.source();
    this.start();
  }

  start() {
    this.updateStatus(1);
    axios({
      method: this.cacheItem.options.method,
      url: this.cacheItem.path,
      data: this.cacheItem.options.body,
      headers: {
        // ...axiosConfig.auth.headers,
        cancelToken: this.source.token,
      }
    })
    .then(res => {
      // console.log(res)
      let resData = res.data.data !== undefined ? res.data.data : res.data;
      if (this.tabSettings.responseKey) resData = resData[this.tabSettings.responseKey];
      if (this.tabSettings.responseCellKey) resData = resData.map(obj => obj[this.tabSettings.responseCellKey]);
      // if nested _id return (obj)._id.data from objects
      let data = (Array.isArray(resData)
        ? resData.filter(val => val !== null).map(obj => {
          let keys;
          if (obj) keys = Object.keys(obj)
          if (keys && keys.length === 1 && keys[0] === '_id') {
            return obj._id;
          } else {
            return obj;
         }
        })
      : resData);
      // remove any null values from the array
      if (Array.isArray(data)) data = data.filter(obj => obj !== null);

      // if nested _id return (obj)._id.data from objects
      this.updateItem({
        data: data,
        status: 2
      })
    })
    .catch(err => {
      checkResponseErrorCodeAndRedirect(err);
      this.updateItem({
        data: null,
        status: axios.isCancel(err) ? 4 : 0,
      })
    })
  }

  stop(message) {
    this.source.cancel(message);
  }
}

export default QueItem;
